import React from 'react';

export function TextArea({ label, requiredField, charCount, maxCount, value, onChange, path, disable, error }) {
  return (
    <>
      <div className="input-group input-floating-label fixed-label remove-border-text-box ">
        <label className="asterisk-req">
          {label}
          {requiredField && <span>*</span>}
        </label>
        <textarea name={label} id={label} value={value} autoComplete="off" disabled={disable} onChange={(event) => onChange(event.target.value, path)} />
        {charCount && <div className="text-count">0/{maxCount}</div>}
      </div>
      {error?.status && <span className="error-message">{error.errorMsg}</span>}
    </>
  );
}
export default TextArea;
